// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoSection_videoWrapper__VZB9B","hasContent":"VideoSection_hasContent__P315u","video":"VideoSection_video__iLbll","small":"VideoSection_small__v2OrL"};